import { render, staticRenderFns } from "./LCalendar.vue?vue&type=template&id=2bba267a&"
import script from "./LCalendar.vue?vue&type=script&lang=js&"
export * from "./LCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports